/* globals google */

import React, { Component } from 'react';
import { get } from 'lodash';

import Marker from './marker';

class RouteMarker extends Component {
  get coordinates() {
    const { location } = this.props;
    return get(location, 'geometry.coordinates', null);
  }

  get markerProps() {
    const { coordinates } = this;
    const { isFirst, isLast } = this.props;

    const markerProps = {
      position: { lat: coordinates[1], lng: coordinates[0] },
      markerStyle: {
        path: google.maps.SymbolPath.CIRCLE,
        scale: 8,
        fillOpacity: 0.2,
        strokeWeight: 0.75,
        fillColor: 'grey',
      },
    };

    if (isFirst || isLast) {
      markerProps.markerStyle.fillOpacity = 1;
      markerProps.markerStyle.scale = 20;
    }
    if (isFirst) {
      markerProps.markerStyle.fillColor = 'green';
    } else if (isLast) {
      markerProps.markerStyle.fillColor = 'red';
    }
    return markerProps;
  }

  render() {
    if (this.coordinates) {
      return (
        <Marker
          marker={this.markerProps}
          onClick={() => {}}
        />
      );
    } else {
      return null;
    }
  }
}

export default RouteMarker;
